//deps
import styled from "styled-components";

//components
import { RoundCloseIcon } from "@core-ui/components/round-close-icon";

const containerWidth = 264;
const tooltipCloseIconHeight = 16;
const arrowDimensions = 12;

export const Container = styled.div<{ bottomArrowPosition: "left" | "right" }>`
    padding: ${(props) =>
        `${props.theme.spacing.small} ${props.theme.spacing.large} ${props.theme.spacing.small} ${props.theme.spacing.small}`};
    background-color: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
    border-radius: ${(props) => props.theme.cornerRadius.small};
    width: ${containerWidth}px;
    height: fit-content;
    display: flex;
    position: relative;

    &:before {
        //arrow
        content: "";
        width: ${arrowDimensions}px;
        height: ${arrowDimensions}px;
        background-color: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
        position: absolute;
        bottom: 0px;
        left: ${(props) => (props.bottomArrowPosition === "left" ? "21px" : "inherit")};
        right: ${(props) => (props.bottomArrowPosition === "right" ? "21px" : "inherit")};
        transform: translateY(47%) rotate(-45deg);
        border-radius: 0 0 0 ${(props) => props.theme.cornerRadius.xxSmall};
        clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
    }
`;

export const TooltipCloseIcon = styled(RoundCloseIcon)`
    background-color: transparent;
    height: ${tooltipCloseIconHeight}px;
    align-self: baseline;
`;
